export const getPathHash = (element: string) => {
    return element
        .replace(/[ ]*-[ ]*/g, "-")
        .replaceAll(" ", "-")
};

export const SingleFilesFolderName = "Single files";

export const DocsendFolderName = 'DocSend';